import { createFileRoute } from "@tanstack/react-router";

import { InterviewSetupScreen } from "../features/interview/setup/InterviewSetupScreen.tsx";

function SetupRoute() {
  const { id } = Route.useParams();
  return <InterviewSetupScreen meetingId={id} />;
}

export const Route = createFileRoute("/_app/interviews/$id/setup")({
  component: SetupRoute,
});
